__turbopack_context__.v({
  "container": "logo-carousel-module__4G9nZG__container",
  "content": "logo-carousel-module__4G9nZG__content",
  "list": "logo-carousel-module__4G9nZG__list",
  "loop": "logo-carousel-module__4G9nZG__loop",
  "looping": "logo-carousel-module__4G9nZG__looping",
  "play-button": "logo-carousel-module__4G9nZG__play-button",
  "playing": "logo-carousel-module__4G9nZG__playing",
  "view": "logo-carousel-module__4G9nZG__view",
});
